// Typelizer digest 8dd3ce4a537a8cee0ea1ba0ef4c3ec6d
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../../runtime'
import { buildUrl } from '../../../runtime'

export default {
  /** GET /c/:company_id/ledger/vies_return/declaration */
  show: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/ledger/vies_return/declaration', {}, options),
    method: 'get',
  }),
}
